import { OptionData } from "components/DesignSystem/Combobox/Combobox";

export const filterOptionsByValues = <T extends OptionData>(
  options: T[],
  values: string[]
): T[] => options.filter((option) => values.includes(option.value));
